module.exports = __webpack_public_path__ + "img/bar-radial-graphic.067ccb1c.png";